// Announcement bar: arrows, autoplay (paused on hover/focus and for reduced motion), and the sticky offset for the header.
if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__track');
      this.items = [...this.querySelectorAll('.announcement-bar__item')];
      this.prev = this.querySelector('[data-announcement-prev]');
      this.next = this.querySelector('[data-announcement-next]');
      this.index = 0;
      this.prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      this.next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      if (this.dataset.pause === 'true') {
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));
      }
      this.resizeObserver = new ResizeObserver(() => { this.update(); this.setStickyOffset(); });
      this.resizeObserver.observe(this);
      this.update();
      this.start();
      // Selecting an announcement in the theme editor shows it (removed again in disconnectedCallback).
      this.abort = new AbortController();
      document.addEventListener('shopify:block:select', (event) => {
        const i = this.items.findIndex((item) => item.contains(event.target) || item === event.target);
        if (i > -1) { this.stop(); this.go(i); }
      }, { signal: this.abort.signal });
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }

    visible() {
      const shown = Math.round(parseFloat(getComputedStyle(this).getPropertyValue('--ab-visible')) || 1);
      return Math.max(1, Math.min(shown, this.items.length));
    }

    maxIndex() {
      return Math.max(0, this.items.length - this.visible());
    }

    update() {
      const scrollable = this.maxIndex() > 0;
      this.prev.hidden = !scrollable;
      this.next.hidden = !scrollable;
      this.go(Math.min(this.index, this.maxIndex()));
    }

    go(index) {
      const max = this.maxIndex();
      this.index = index < 0 ? max : index > max ? 0 : index;
      this.track.style.transform = `translateX(${(-100 / this.visible()) * this.index}%)`;
      this.items.forEach((item, i) => item.toggleAttribute('inert', i < this.index || i >= this.index + this.visible()));
    }

    start() {
      const seconds = Number(this.dataset.autoplay);
      if (!seconds || this.maxIndex() === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }

    stop() {
      clearInterval(this.timer);
    }

    restart() {
      if (this.matches(':hover, :focus-within') && this.dataset.pause === 'true') return;
      this.start();
    }

    // A sticky announcement bar pushes a sticky header down by its height.
    setStickyOffset() {
      if (this.dataset.sticky === 'true') document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
    }
  });
}
